import { PAYMENTS_SECTIONS_ROUTES } from '@/models/app-internal/permissions.model';
import { RouteComponent, RouteRecordRaw } from 'vue-router';

export const pspTagRoutes: RouteRecordRaw[] = [
  {
    name: PAYMENTS_SECTIONS_ROUTES.PSP_TAGS,
    path: `/${PAYMENTS_SECTIONS_ROUTES.PSP_TAGS}`,
    component: async(): Promise<RouteComponent> =>
      await import('@/layouts/psp-tags-page/psp-tags-page.vue'),
  },
];
